// extracted by mini-css-extract-plugin
export default {"display":"Woz8P7","iframe":"eZTjsa"};